import { Category } from '@/types/events'
import Tooltip from '@/components/Tooltip'

interface CategoryBadgeGroupProps {
  categories: Category[]
  maxDisplay?: number
}

export function CategoryBadgeGroup({ categories, maxDisplay = 1 }: CategoryBadgeGroupProps) {
  if (categories.length === 0) {
    return <span>-</span>
  }

  // Get the names of categories not displayed (for tooltip)
  const hiddenCategories = categories.slice(maxDisplay)
  const hiddenCategoryNames = hiddenCategories.map((cat) => cat.name).join(', ')

  return (
    <div className="flex items-center gap-1">
      <div className="inline-block px-3 py-1 bg-blue-50 border border-[#D9D9D9] rounded text-xs">
        {categories[0].name}
      </div>
      {categories.length > maxDisplay && (
        <Tooltip title={hiddenCategoryNames} placement="top">
          <div className="inline-block px-3 py-1 bg-blue-50 border border-[#D9D9D9] rounded text-xs cursor-pointer">
            +{categories.length - maxDisplay}
          </div>
        </Tooltip>
      )}
    </div>
  )
}
